import { render, staticRenderFns } from "./formField.vue?vue&type=template&id=16cf8bb6&scoped=true"
import script from "./formField.vue?vue&type=script&lang=js"
export * from "./formField.vue?vue&type=script&lang=js"
import style0 from "./formField.vue?vue&type=style&index=0&id=16cf8bb6&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16cf8bb6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16cf8bb6')) {
      api.createRecord('16cf8bb6', component.options)
    } else {
      api.reload('16cf8bb6', component.options)
    }
    module.hot.accept("./formField.vue?vue&type=template&id=16cf8bb6&scoped=true", function () {
      api.rerender('16cf8bb6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/formField.vue"
export default component.exports